<template>
  <v-navigation-drawer v-model="trialFlag" :width="500" fixed temporary right @input="setFlag">
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>Renewal Date</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closeDrawer" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-list three-line>
      <div class="pa-4">
        <date-picker :key="companyId" :color="datePickerColor"></date-picker>
          <v-radio-group v-model="invoiceMethod" row class="mt-5" :error-messages="messages.invoice_type">
              <strong>Invoiced :</strong>
          <div class="d-inline-flex mt-1">
            <v-radio label="Monthly" value="Monthly"></v-radio>
            <v-radio label="Annually" value="Annually"></v-radio>
          </div>
        </v-radio-group>
      </div>
    </v-list>
    <v-footer absolute height="68">
      <v-flex>
        <div class="text-right">
          <v-btn color="grey300" class="cancel-button" @click="closeDrawer">Cancel</v-btn>
          <v-btn class="ml-4" v-if="loading" color="primary" loading></v-btn>
          <v-btn class="ml-4" v-else color="primary" :disabled="selectedDate === 'Not Set'"
            @click="updateRenewalDate">Update</v-btn>
        </div>
      </v-flex>
    </v-footer>
  </v-navigation-drawer>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import DatePicker from '@/components/admin/global/Datepicker';
import companyAPI from '@/api/company.js';

export default {
  name: 'RenewalDateDrawer',
  components: {
    DatePicker,
  },
  props: {
    renewalDateDrawer: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: String,
      required: true,
    },
    invoiceType: {
      type: String,
      default: "",
    }

  },
  data() {
    return {
      selectedDate: 'Not Set',
      loading: false,
      trialFlag: false,
      messages: {},
      successMessage: "Renewal date updated successfully.",
      errorMessage: "Oops, something went wrong! Please check information is correct.",
    };
  },


  mounted() {
    this.setEventBus();
  },
  computed: {
    datePickerColor() {
      return this.$gf.headerColor();
    },
    invoiceMethod: {
      get() {
        // Getter — read from the prop
        return this.invoiceType
      },
      set(newValue) {
        // Setter — emit event to parent
         this.$emit('update:invoiceType', newValue)
      }
    }
  },
  methods: {
    setFlag() {
      EventBus.$emit('RENEWALDATE_DRAWER_STATE', this.trialFlag);
    },
    closeDrawer() {
      this.invoiceType = "";
      this.selectedDate = 'Not Set';
      this.messages = {}
      EventBus.$emit('RENEWALDATE_DRAWER_STATE', false);
    },
    updateRenewalDate() {

      this.loading = true;
      companyAPI
        .updateCompanyRenewal(this.companyId, this.selectedDate, this.invoiceMethod)
        .then((resp) => {
          this.loading = false;
          this.$snotify.success(this.successMessage);
          EventBus.$emit('RENEWAL_DATE_STATE_UPDATED', true);
          this.closeDrawer();
           setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        }).catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });

    },
    setEventBus() {
      EventBus.$on('DATE_SELECTED', (date) => {
        this.selectedDate = date;
      });
    },
  },
  watch: {
    renewalDateDrawer: {
      handler(value) {
        this.trialFlag = value;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.v-picker--date .v-picker__title {
  display: none;
}
.v-picker--date .v-picker__body {
  margin: 0 auto !important;
}
</style>
